// validationSchema.ts
import { array, object, number, string, boolean } from 'yup';
import { ALPHANUMERIC_REGEX } from './constants';
import provinceValidation from 'shared/utils/provinceValidation';

export const validationSchema = object({
  locations: array()
    .of(
      object({
        name: string()
          .required('Required')
          .max(30, 'Must be 30 characters or less')
          .matches(
            ALPHANUMERIC_REGEX,
            'Name only includes alphanumeric values'
          ),
        category: string().required('Required'),
        belongs: string().required('Required'),
        city: string().required('Required'),
        street: string().required('Required').nullable(),
        country: string().required('Required'),
        postalCode: string()
          .matches(
            ALPHANUMERIC_REGEX,
            'Postal code must be alphanumeric and may include spaces'
          )
          .min(2, 'Postal code must be at least 2 characters')
          .max(8, 'Postal code must be at most 8 characters')
          .nullable(),
        countryCode: string().required('Required'),
        province: provinceValidation,
        latitude: string().required('Required'),
        longitude: string().required('Required'),
      })
    )
    .min(1, 'At least one location is required'),
});

export const validationSchemaYears = object({
  years: array().of(
    object({
      year: number().required('Year is required'),
      share_percentage: number()
        .typeError('Share percentage must be a number')
        .when('enabled', {
          is: true,
          then: number()
            .min(0, 'Share percentage must be at least 0')
            .max(100, 'Share percentage must be at most 100')
            .required('Share percentage is required when enabled'),
          otherwise: number().notRequired(),
        }),
      enabled: boolean().required(),
    })
  ),
});
